<template>
    <div class="container-fluid">
        <Breadcrumb title="Categories">
            <button type="button" class="btn btn-info d-none d-lg-block m-l-15" @click="addCategory"
                    data-toggle="modal" data-target="#exampleModal" data-whatever="@fat"><i
                    class="fa fa-plus-circle"></i> Create New
            </button>
        </Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-if="loading">
                <Preloader v-bind:class="{preloader: loading}"></Preloader>
            </div>
            <div class="col-12" v-else>
                <div class="card">
                    <div class="card-body">
                        <v-jstree :data="categories" v-if="categories.length > 0"
                                  multiple
                                  allow-batch
                                  whole-row
                                  ref="tree">
                            <template slot-scope="_" class="p-b-30">
                                <div style="display: inherit; width: 200px;">
                                    <i :class="_.vm.themeIconClasses" role="presentation"
                                       v-if="!_.model.loading"></i>
                                    {{_.model.text}}
                                    <button style="border: 0px; background-color: transparent; cursor: pointer;"
                                            @click="addChildren(_.vm, _.model, $event)"><i
                                            class="mdi mdi-plus-box"></i>
                                    </button>
                                    <button style="border: 0px; background-color: transparent; cursor: pointer;"
                                            @click="editCategory(_.vm, _.model, $event)"><i
                                            class="mdi mdi-pencil"></i>
                                    </button>
                                    <button style="border: 0px; background-color: transparent; cursor: pointer;"
                                            @click="removeCategory(_.vm, _.model, $event)"><i
                                            class="mdi mdi-delete"></i></button>
                                </div>
                            </template>
                        </v-jstree>
                        <div class="card w-75" v-else>
                            <div class="card-body">
                                <h3 class="card-title">Tree categories is empty!</h3>
                                <a href="javascript:void(0)" @click="addCategory" class="btn btn-danger">
                                    Create New Category
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VJstree from 'vue-jstree';
    import Swal from 'sweetalert2';
    import CategoryService from '../services/CategoryService';
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';

    export default {
        name: 'Categories',
        components: {
            Breadcrumb,
            VJstree, Preloader
        },
        data() {
            return {
                categories: [],
                loading: false,
                editingItem: {},
                editingNode: null,
            }
        },
        mounted() {
            this.loading = true;
            this.getCategories();
        },
        methods: {
            getCategories() {
                CategoryService.getCategories()
                    .then(categories => {
                        this.categories = categories.data;
                        this.loading = false;
                    });
            },
            validate(response) {
                if (response !== undefined) {
                    this.errors = response.data.error;
                    for (let error in this.errors) {
                        for (let key in this.errors[error]) {
                            Swal.showValidationMessage(`${this.errors[error][key]}`)
                        }
                    }
                }
            },
            addCategory() {
                Swal({
                    title: 'Add Category',
                    input: 'text',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: (category) => {
                        if (category) {
                            return CategoryService.createCategory(category).then(response => {
                                if (response.status === 201) {
                                    this.categories.push({
                                        id: response.data.id,
                                        text: response.data.name,
                                    });
                                }
                            }).catch(response => {
                                this.validate(response.response);
                            });
                        }
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Added successfully!',
                            `Category ${result.value}  has been added.`,
                            'success'
                        )
                    }
                })
            },
            editCategory(node) {
                this.editingNode = node;
                this.editingItem = node.model;
                Swal({
                    title: 'Edit category ' + `${node.model.text}`,
                    text: 'Please edit category and press confirm!',
                    input: 'text',
                    inputValue: node.model.text,
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: (category) => {
                        if (node) {
                            return CategoryService.updateCategory(node.model.id, category).then(response => {
                                if (response.status === 200) {
                                    this.editingItem['text'] = response.data.name;
                                    Swal(
                                        'Updated!',
                                        'Category has been updated.',
                                        'success'
                                    )
                                }
                            }).catch(response => {
                                this.validate(response.response);
                            });
                        }
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Updated successfully!',
                            `Category ${result.value}  has been updated.`,
                            'success'
                        )
                    }
                })

            },
            removeCategory(node) {
                this.editingNode = node;
                this.editingItem = node.model;
                Swal({
                    title: 'Are you sure?',
                    text: 'You will not be able to recover this category!',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },

                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        if (node) {
                            return CategoryService.deleteCategory(node.model.id).then(response => {
                                if (response.status === 204) {
                                    if (this.editingItem.id !== undefined) {
                                        let index = this.editingNode.parentItem.indexOf(this.editingItem);
                                        this.editingNode.parentItem.splice(index, 1);
                                        Swal(
                                            'Deleted!',
                                            'Category has been deleted.',
                                            'success'
                                        )
                                    }
                                }
                                if(response.status === 500) {
                                    Swal.showValidationMessage(
                                        `Delete failed: ${response.data.error}`
                                    );
                                    return false;
                                }
                            }).catch(error => {
                                Swal.showValidationMessage(
                                    `Request failed: ${error}`
                                )
                            });
                        }
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Removed successfully!',
                            `Category has been removed.`,
                            'success'
                        )
                    }
                })
            },

            addChildren(node) {
                this.editingNode = node;
                this.editingItem = node.model;
                Swal({
                    title: 'Add category',
                    input: 'text',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: (category) => {
                        if (category) {
                            return CategoryService.createCategory(category, node.model.id).then(response => {
                                if (response.status === 201) {
                                    if (this.editingItem.id !== undefined) {
                                        this.editingItem.addChild({
                                            id: response.data.id,
                                            text: response.data.name,
                                            children: []
                                        });
                                    }
                                }
                            }).catch(response => {
                                this.validate(response.response);
                            });
                        }
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Added successfully!',
                            `Category ${result.value}  has been added.`,
                            'success'
                        )
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>